import React, { useCallback, useEffect, useState } from "react";
import bybStyle from "../../Assets/css/BandBuilder.module.css";
import BuildYourBandSkeletan from "./BandBuilderSkeletan.js";
import ToggleButton from "react-bootstrap/ToggleButton";
import {
  Button,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { CiImageOn } from "react-icons/ci";
import { BsArrowRight } from "react-icons/bs";
import {
  FINISH_OBJ,
  LOGIN_FIRST_MESSAGE,
  METAL_COLOR_OBJ,
  METAL_TYPE_OBJ,
  PROFILE_OBJ,
  THICKNESS_OBJ,
} from "../../Constants/constants";
import axios from "axios";
import { base_url, currency, postHeader } from "../../Helpers/request.js";
import { toast } from "react-toastify";
import { setBandBuilderData } from "../../Reducer/bandReducer.js";
import { useDispatch, useSelector } from "react-redux";
import { loginDrawer, sessionId, Setuser } from "../../Reducer/homeReducer.js";
import { CircularProgress } from "@material-ui/core";
import { cartlengthvalue } from "../../Reducer/cartReducer.js";
import { Wishlengthvalue } from "../../Reducer/wishlistReducer.js";
import { useHistory } from "react-router-dom";
import { isMobile, isMobileOnly } from "react-device-detect";

const BandBuilder = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { byb } = useSelector((state) => state.persistedReducer.bandBuilder);
  const currencycode = useSelector(
    (state) => state.persistedReducer.home.currencycode
  );

  const session_Id = useSelector(
    (state) => state.persistedReducer.home.session_id
  );
  const user = useSelector(
    (state) => state.persistedReducer.home.userData
  );
  const [priceLoading, setPriceLoading] = useState(true);
  const [bybData, setBybData] = useState(null);
  const [selectedVariant, setselectedVariant] = useState(null);
  const [selectedVals, setSelectedVals] = useState(null);
  const [isFetchingApi, setIsFetchingApi] = useState(true);
  const [noData, setNoData] = useState(false);
  const [metalColors, setMetalColors] = useState(null);
  const [bandImg, setBandImg] = useState(null);
  const [imgError, setImgError] = useState(false);
  const [profileAndMetalType, setProfileAndMetalType] = useState({
    profile: "",
    metal_type: "",
  });
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [isAddingToCart, setAddingTocart] = useState(false);
  const [fetchingDataAgain, setFetchingDataAgain] = useState(false);

  const fetchData = useCallback(async () => {
    // let obj = {};
    // if (user) {
    //   obj = { ...obj, token: user?.token, user_id: user?.id };
    // }

    var data = {};
    axios
      .post(base_url + "/band_builder/build_your_own_band", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          dispatch(setBandBuilderData({ byb: response.data.data }));
          setIsFetchingApi(false);
          //toast.success(response.data.message, { autoClose: 3000 });
        } else {
          setNoData(true);
          setIsFetchingApi(false);
          toast.error(response.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        setIsFetchingApi(false);
        console.log(error);
      });
  }, []);

  const fetchDataAgain = useCallback(async () => {
    let obj = { ...profileAndMetalType };
    if (obj.profile === "") {
      obj = { ...obj, profile: selectedVariant?.profile };
    }
    if (obj.metal_type === "") {
      obj = { ...obj, metal_type: selectedVariant?.metal_type };
    }
    // if (user) {
    //   obj = { ...obj, token: user?.token, user_id: user?.id };
    // }

    axios
      .post(base_url + "/band_builder/build_your_own_band", obj, {
        headers: postHeader,
      })
      .then(async (response) => {
        if (response.data.status == 1) {
          setMetalColors(response.data?.data?.details?.metal_color);
          setFetchingDataAgain(false);
          if (response.data?.data?.details?.metal_color?.value?.length) {
            const existingClr = await response.data?.data?.details?.metal_color?.value.find(
              (item) => item?.id === selectedVariant?.metal_color
            );
            if (existingClr?.id) {
              setselectedVariant({
                ...selectedVariant,
                metal_color: existingClr?.id,
              });
            } else {
              setselectedVariant({
                ...selectedVariant,
                metal_color:
                  response.data?.data?.details?.metal_color?.value?.[0]?.id,
              });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [profileAndMetalType, selectedVariant]);

  useEffect(() => {
    if (
      profileAndMetalType?.profile !== "" ||
      profileAndMetalType?.metal_type !== ""
    ) {
      fetchDataAgain();
    }
  }, [profileAndMetalType]);

  useEffect(() => {
    if (byb) {
      setBybData(byb);
      if (byb?.initial_values) {
        setselectedVariant(byb?.initial_values);
        setBandImg(byb?.initial_values?.variant_image);
      }
      if (byb?.details?.metal_color) {
        setMetalColors(byb?.details?.metal_color);
      }
      if (byb?.selected_values) {
        setSelectedVals(byb?.selected_values);
      }
    }
  }, [byb]);

  const fetchPrice = useCallback(async () => {
    setPriceLoading(true);
    let selectedVariantData = { ...selectedVariant };
    delete selectedVariantData.variant_id;
    delete selectedVariantData.variant_image;
    let data = { ...selectedVariantData, currency_code: currencycode };
    if (user?.isLogin) {
      data = {
        ...data,
        token: user?.token,
        user_id: user?.user_id,
      };
    } else {
      data = {
        ...data,
        session_id: session_Id,
      };
    }

    axios
      .post(base_url + "/band_builder/getBandPrice", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setPurchasePrice(response.data.data.sale_price);
          setPriceLoading(false);
        }
        //  else {
        //   setPurchasePrice(0);
        // }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedVariant]);

  useEffect(() => {
    if (selectedVariant) {
      //variant_id ------> profile_finish_metal_color_mm_width
      setImgError(false);
      setBandImg(
        byb?.image_base_url?.replace(
          "***",
          `${selectedVariant?.profile}_${selectedVariant?.finish}_${selectedVariant?.metal_color}_${selectedVariant?.mm_width}`
        )
      );
      if (!fetchingDataAgain) {
        fetchPrice();
      }
    }
  }, [selectedVariant]);

  useEffect(() => {
    fetchData();
  }, []);

  const handleAddToCart = useCallback(async () => {
    setAddingTocart(true);
    let data = {
      ...selectedVariant,
      // session_id: session_Id,
      image_url: bandImg ? bandImg : "",
      quantity: "1",
      type: "jewelry",
    };

    if (user?.isLogin) {
      data = {
        ...data,
        token: user?.isLogin ? user?.token : "",
        user_id: user?.user_id ? user?.user_id : "",
      };
    } else {
      data = {
        ...data,
        session_id: session_Id,
      };
    }

    axios
      .post(base_url + "/band_builder/add_to_cart", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setAddingTocart(false);
          dispatch(cartlengthvalue(res?.data?.data?.total_count));
          history.push("/cart");
          toast.success(res.data.message, { autoClose: 3000 });
        } else if (res.data.status == 2) {
          setAddingTocart(false);
          dispatch(Setuser([]));
          dispatch(Wishlengthvalue(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(""));
          history.push("/");
          // window.location.reload(true);
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
          setAddingTocart(false);
        }
      })
      .catch((error) => {
        setIsFetchingApi(false);
        console.log(error);
      });
  }, [selectedVariant, byb, user, bandImg, user?.isLogin]);

  //   const login2ViewPrice = (prod) => {
  //     dispatch(
  //       setAuthData({
  //         loginFromBybDetails: true,
  //         cmsIdFromProDetails: prod?.cms_id,
  //         skuFromProDetails: prod?.cms_id,
  //       })
  //     );
  //     router.push("/login");
  //   };

  // console.log("selectedVariant", selectedVariant);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className={bybStyle.BuildYourBandPage + "  p-0"}>
      <Container fluid className="showcase-container">
        {isFetchingApi ? (
          <BuildYourBandSkeletan />
        ) : noData ? (
          <h1>No Data Image</h1>
        ) : (
          <Row>
            <Col lg={6} md={12} xs={12}>
              {/* <h1 className={bybStyle.bybLeftbox_title}>BUILD YOUR OWN BAND</h1> */}
              <div
                className={
                  isMobileOnly && scrolled
                    ? bybStyle.bybLeftbox + " " + bybStyle.scrolledFixed
                    : bybStyle.bybLeftbox
                }
              >
                <div className={bybStyle.bybImagebox}>
                  {bandImg && !imgError ? (
                    <img
                      height={500}
                      width={850}
                      className="img-fluid"
                      src={bandImg}
                      alt="band_img"
                      onError={() => {
                        setImgError(!imgError);
                      }}
                    />
                  ) : (
                    <div className={bybStyle.pro_not_found}>
                      <CiImageOn />
                      <h3>PRODUCT IMAGE NOT AVAILABLE</h3>
                    </div>
                  )}
                </div>
                <div className={bybStyle.bybaddedFilters}>
                  {/* {selectedVals?.length ? (
                      <ul>
                        {selectedVals?.map((sv, svid) => (
                          <li key={svid} className="">
                            <a href={`#${sv?.key}`}>
                              <span>{sv?.title}</span> {sv?.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    ) : null} */}
                  <ul>
                    <li className="">
                      <span>PROFILE</span>
                      {PROFILE_OBJ[selectedVariant?.profile]}
                    </li>
                    <li className="">
                      <span>METAL TYPE</span>
                      {METAL_TYPE_OBJ[`_${selectedVariant?.metal_type}`]}
                    </li>
                    <li className="">
                      <span>COLOR</span>
                      {METAL_COLOR_OBJ[selectedVariant?.metal_color]}
                    </li>
                    <li className="">
                      <span>FINISH</span>
                      {FINISH_OBJ[selectedVariant?.finish]}
                    </li>
                    <li className="">
                      <span>WIDTH </span>
                      {selectedVariant?.mm_width}
                    </li>
                    <li className="">
                      <span>THICKNESS</span>
                      {THICKNESS_OBJ[selectedVariant?.thickness]}
                    </li>
                    <li className="">
                      <span>SIZE</span>
                      {selectedVariant?.ring_size}
                    </li>
                  </ul>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <Button
                    variant="none"
                    className={bybStyle.bybBtnTheme}
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddToCart();
                      // if (user?.isLogin) {
                      //   handleAddToCart();
                      // } else {
                      //   toast.error(LOGIN_FIRST_MESSAGE, { autoClose: 3000 });
                      // }
                    }}
                    disabled={
                      priceLoading || purchasePrice === 0 || isAddingToCart
                    }
                  >
                    Add To Cart <BsArrowRight />
                  </Button>
                  <p className={bybStyle.bybprice}>
                    {priceLoading ? (
                      <CircularProgress thickness={5} className="rcs_loader" />
                    ) : !priceLoading && purchasePrice !== 0 ? (
                      <b>
                        Price: {currency}{currencycode}
                        {purchasePrice}
                      </b>
                    ) : null}
                  </p>
                  {/* {user?.user?.isLogin ? (
                    <p className={bybStyle.bybprice}>
                      {priceLoading ? (
                        <CircularProgress
                          thickness={5}
                          className="rcs_loader"
                        />
                      ) : !priceLoading && purchasePrice !== 0 ? (
                        <b>
                          Price: {currency}
                          {purchasePrice}
                        </b>
                      ) : null}
                    </p>
                  ) : (
                    <p className={bybStyle.bybprice}>
                      <span>
                        <strong
                          style={{ cursor: "pointer" }}
                          onClick={() => dispatch(loginDrawer(true))}
                        >
                          Login
                        </strong>{" "}
                        to view price.
                      </span>
                    </p>
                  )} */}
                </div>
              </div>
            </Col>
            <Col lg={6} md={12} xs={12}>
              <div className={bybStyle.bybFilterbox}>
                {byb?.details?.profile ? (
                  <div
                    className={bybStyle.bybFilterboxInner}
                    id={byb?.details?.profile?.key}
                  >
                    <h1 className={bybStyle.bybFilterTitle}>
                      {byb?.details?.profile?.name}
                    </h1>
                    <div
                      className={
                        bybStyle.bybFilterInnerbox +
                        " " +
                        bybStyle.profile_InnerBoxDataList
                      }
                    >
                      <ul className={bybStyle.bybFilterList}>
                        {byb?.details?.profile?.value?.length &&
                          byb?.details?.profile?.value.map((val, valId) => (
                            <li>
                              <ToggleButton
                                key={`${byb?.details?.profile?.key}-${val}-${valId}`}
                                id={`${byb?.details?.profile?.key}-${val}-${valId}`}
                                type="radio"
                                variant={"outline-defult"}
                                name={val?.name}
                                value={val?.id}
                                checked={
                                  selectedVariant[
                                  byb?.details?.profile?.key
                                  ] === val?.id
                                }
                                onChange={(e) => {
                                  setFetchingDataAgain(true);
                                  setProfileAndMetalType({
                                    ...profileAndMetalType,
                                    profile: e?.target?.value,
                                  });

                                  setselectedVariant({
                                    ...selectedVariant,
                                    [byb?.details?.profile?.key]: e?.target
                                      ?.value,
                                  });
                                }}
                              >
                                {/* <OverlayTrigger
                                  overlay={(props) => (
                                    <Tooltip {...props}>{val?.name}</Tooltip>
                                  )}
                                  placement="top"
                                > */}
                                <div>
                                  {byb?.details?.profile?.base_url ? (
                                    <img
                                      height={40}
                                      width={40}
                                      alt={valId}
                                      src={byb?.details?.profile?.base_url.replace(
                                        "***",
                                        val?.id
                                      )}
                                    />
                                  ) : null}
                                  <span>{val?.name}</span>
                                </div>
                                {/* </OverlayTrigger> */}
                              </ToggleButton>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ) : null}
                {byb?.details?.metal_type ? (
                  <div
                    className={bybStyle.bybFilterboxInner}
                    id={byb?.details?.metal_type?.key}
                  >
                    <h1 className={bybStyle.bybFilterTitle}>
                      {byb?.details?.metal_type?.name}
                    </h1>
                    <div
                      className={
                        bybStyle.bybFilterInnerbox +
                        " " +
                        bybStyle.metal_type_InnerBoxDataList
                      }
                    >
                      <ul className={bybStyle.bybFilterList}>
                        {byb?.details?.metal_type?.value?.length &&
                          byb?.details?.metal_type?.value.map((val, valId) => (
                            <li>
                              <ToggleButton
                                key={`${byb?.details?.metal_type?.key}-${val}-${valId}`}
                                id={`${byb?.details?.metal_type?.key}-${val}-${valId}`}
                                type="radio"
                                variant={"outline-defult"}
                                name={val?.name}
                                value={val?.id}
                                checked={
                                  selectedVariant[
                                  byb?.details?.metal_type?.key
                                  ] === val?.id
                                }
                                onChange={(e) => {
                                  setFetchingDataAgain(true);
                                  setProfileAndMetalType({
                                    ...profileAndMetalType,
                                    metal_type: e?.target?.value,
                                  });
                                  setselectedVariant({
                                    ...selectedVariant,
                                    [byb?.details?.metal_type?.key]: e?.target
                                      ?.value,
                                  });
                                }}
                              >
                                <OverlayTrigger
                                  overlay={(props) => (
                                    <Tooltip {...props}>{val.name}</Tooltip>
                                  )}
                                  placement="top"
                                >
                                  <div>
                                    {byb?.details?.metal_type?.base_url ? (
                                      <img
                                        height={40}
                                        width={40}
                                        alt={valId}
                                        src={byb?.details?.metal_type?.base_url.replace(
                                          "***",
                                          val?.id
                                        )}
                                      />
                                    ) : null}
                                    <span
                                      className={
                                        byb?.details?.metal_type?.base_url
                                          ? ""
                                          : bybStyle.noimgfilter
                                      }
                                    >
                                      {" "}
                                      {val.id === "L"
                                        ? "PAL"
                                        : val.id === "P"
                                          ? "PLT"
                                          : val.name}
                                    </span>
                                  </div>
                                </OverlayTrigger>
                              </ToggleButton>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ) : null}
                {metalColors ? (
                  <div
                    className={bybStyle.bybFilterboxInner}
                    id={metalColors?.key}
                  >
                    <h1 className={bybStyle.bybFilterTitle}>
                      {metalColors?.name}
                    </h1>
                    <div
                      className={
                        bybStyle.bybFilterInnerbox +
                        " " +
                        bybStyle.metalColors_InnerBoxDataList
                      }
                    >
                      <ul className={bybStyle.bybFilterList}>
                        {metalColors?.value?.length &&
                          metalColors?.value.map((val, valId) => (
                            <li>
                              <ToggleButton
                                key={`${metalColors?.key}-${val}-${valId}`}
                                id={`${metalColors?.key}-${val}-${valId}`}
                                type="radio"
                                variant={"outline-defult"}
                                name={val?.name}
                                value={val?.id}
                                checked={
                                  selectedVariant[metalColors?.key] === val.id
                                }
                                onChange={(e) => {
                                  setselectedVariant({
                                    ...selectedVariant,
                                    [metalColors?.key]: e?.target?.value,
                                  });
                                }}
                              >
                                <OverlayTrigger
                                  overlay={(props) => (
                                    <Tooltip {...props}>{val?.name}</Tooltip>
                                  )}
                                  placement="top"
                                >
                                  <div>
                                    {metalColors?.base_url ? (
                                      <img
                                        height={40}
                                        width={40}
                                        alt={valId}
                                        src={metalColors?.base_url.replace(
                                          "***",
                                          val?.id
                                        )}
                                      />
                                    ) : null}
                                    <span>{val.id}</span>
                                  </div>
                                </OverlayTrigger>
                              </ToggleButton>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ) : null}

                {byb?.details?.finish ? (
                  <div
                    className={bybStyle.bybFilterboxInner}
                    id={byb?.details?.finish?.key}
                  >
                    <h1 className={bybStyle.bybFilterTitle}>
                      {byb?.details?.finish?.name}
                    </h1>
                    <div
                      className={
                        bybStyle.bybFilterInnerbox +
                        " " +
                        bybStyle.finish_InnerBoxDataList
                      }
                    >
                      <ul className={bybStyle.bybFilterList}>
                        {byb?.details?.finish?.value?.length &&
                          byb?.details?.finish?.value.map((val, valId) => (
                            <li>
                              <ToggleButton
                                key={`${byb?.details?.finish?.key}-${val}-${valId}`}
                                id={`${byb?.details?.finish?.key}-${val}-${valId}`}
                                type="radio"
                                variant={"outline-defult"}
                                name={val?.name}
                                value={val?.id}
                                checked={
                                  selectedVariant[byb?.details?.finish?.key] ===
                                  val?.id
                                }
                                onChange={(e) =>
                                  setselectedVariant({
                                    ...selectedVariant,
                                    [byb?.details?.finish?.key]: e?.target
                                      ?.value,
                                  })
                                }
                              >
                                {/* <OverlayTrigger
                                  overlay={(props) => (
                                    <Tooltip {...props}>{val?.name}</Tooltip>
                                  )}
                                  placement="top"
                                > */}
                                <div>
                                  {byb?.details?.finish?.base_url ? (
                                    <img
                                      height={40}
                                      width={40}
                                      alt={valId}
                                      src={byb?.details?.finish?.base_url.replace(
                                        "***",
                                        val?.id
                                      )}
                                    />
                                  ) : null}
                                  <span>{val.name}</span>
                                </div>
                                {/* </OverlayTrigger> */}
                              </ToggleButton>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ) : null}
                {byb?.details?.mm_width ? (
                  <div
                    className={bybStyle.bybFilterboxInner}
                    id={byb?.details?.mm_width?.key}
                  >
                    <h1 className={bybStyle.bybFilterTitle}>
                      {byb?.details?.mm_width?.name}
                    </h1>
                    <div
                      className={
                        bybStyle.bybFilterInnerbox +
                        " " +
                        bybStyle.mm_width_InnerBoxDataList
                      }
                    >
                      <ul className={bybStyle.bybFilterList}>
                        {byb?.details?.mm_width?.value?.length &&
                          byb?.details?.mm_width?.value.map((val, valId) => (
                            <li>
                              <ToggleButton
                                key={`${byb?.details?.mm_width?.key}-${val}-${valId}`}
                                id={`${byb?.details?.mm_width?.key}-${val}-${valId}`}
                                type="radio"
                                variant={"outline-defult"}
                                name={val?.name}
                                value={val?.id}
                                checked={
                                  selectedVariant[
                                  byb?.details?.mm_width?.key
                                  ] === val?.id
                                }
                                onChange={(e) =>
                                  setselectedVariant({
                                    ...selectedVariant,
                                    [byb?.details?.mm_width?.key]: e?.target
                                      ?.value,
                                  })
                                }
                              >
                                {/* <OverlayTrigger
                                  overlay={(props) => (
                                    <Tooltip {...props}>{val?.id}</Tooltip>
                                  )}
                                  placement="top"
                                > */}
                                <div>
                                  {byb?.details?.mm_width?.base_url ? (
                                    <img
                                      height={40}
                                      width={40}
                                      alt={valId}
                                      src={byb?.details?.mm_width?.base_url.replace(
                                        "***",
                                        val?.id
                                      )}
                                    />
                                  ) : null}
                                  <span>{val?.name}</span>
                                </div>
                                {/* </OverlayTrigger> */}
                              </ToggleButton>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ) : null}
                {byb?.details?.mm_height ? (
                  <div
                    className={bybStyle.bybFilterboxInner}
                    id={byb?.details?.mm_height?.key}
                  >
                    <h1 className={bybStyle.bybFilterTitle}>
                      {byb?.details?.mm_height?.name}
                    </h1>
                    <div
                      className={
                        bybStyle.bybFilterInnerbox +
                        " " +
                        bybStyle.mm_height_InnerBoxDataList
                      }
                    >
                      <ul className={bybStyle.bybFilterList}>
                        {byb?.details?.mm_height?.value.length &&
                          byb?.details?.mm_height?.value.map((val, valId) => (
                            <li>
                              <ToggleButton
                                key={`${byb?.details?.mm_height?.key}-${val}-${valId}`}
                                id={`${byb?.details?.mm_height?.key}-${val}-${valId}`}
                                type="radio"
                                variant={"outline-defult"}
                                name={val?.name}
                                value={val?.id}
                                checked={
                                  selectedVariant[
                                  byb?.details?.mm_height?.key
                                  ] === val?.id
                                }
                                onChange={(e) =>
                                  setselectedVariant({
                                    ...selectedVariant,
                                    [byb?.details?.mm_height?.key]: e?.target
                                      ?.value,
                                  })
                                }
                              >
                                <OverlayTrigger
                                  overlay={(props) => (
                                    <Tooltip {...props}>{val?.title}</Tooltip>
                                  )}
                                  placement="top"
                                >
                                  <div>
                                    {byb?.details?.mm_height?.base_url ? (
                                      <img
                                        height={40}
                                        width={40}
                                        alt={valId}
                                        src={byb?.details?.mm_height?.base_url.replace(
                                          "***",
                                          val?.id
                                        )}
                                      />
                                    ) : null}
                                    <span
                                      className={
                                        byb?.details?.mm_height?.base_url
                                          ? ""
                                          : bybStyle.noimgfilter
                                      }
                                    >
                                      {val?.name}
                                    </span>
                                  </div>
                                </OverlayTrigger>
                              </ToggleButton>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ) : null}
                {byb?.details?.ring_size ? (
                  <div
                    className={bybStyle.bybFilterboxInner}
                    id={byb?.details?.ring_size?.key}
                  >
                    <h1 className={bybStyle.bybFilterTitle}>
                      {byb?.details?.ring_size?.name}
                    </h1>
                    <div
                      className={
                        bybStyle.bybFilterInnerbox +
                        " " +
                        bybStyle.ring_size_InnerBoxDataList
                      }
                    >
                      <select
                        className={bybStyle.bybFilterList + " form-select"}
                        onChange={(e) =>
                          setselectedVariant({
                            ...selectedVariant,
                            ring_size: e.target.value,
                          })
                        }
                        value={selectedVariant?.ring_size}
                      >
                        {byb?.details?.ring_size?.value.length &&
                          byb?.details?.ring_size?.value.map((s, idx) => (
                            <option value={s.name}>{s.name}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                ) : null}

                {/* <div className={bybStyle.bybFilterboxInner} id="Profile">
                    <h1 className={bybStyle.bybFilterTitle}> Profile</h1>
                    <div className={bybStyle.bybFilterInnerbox}>
                      <ul className={bybStyle.bybFilterList}>
                        {profiles.map((profile, idx) => (
                          <li>
                            <ToggleButton
                              key={idx}
                              id={`profile-${idx}`}
                              type="radio"
                              variant={"outline-defult"}
                              name="profile"
                              value={profile.value}
                              checked={profileValue === profile.value}
                              onChange={(e) =>
                                setprofileValue(e.currentTarget.value)
                              }
                            >
                              <div>
                                {profile.imageUrl ? (
                                  <img alt="" src={profile.imageUrl} />
                                ) : null}
                                <span>{profile.name}</span>
                              </div>
                            </ToggleButton>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={bybStyle.bybFilterboxInner} id="metal_Type">
                    <h1 className={bybStyle.bybFilterTitle}> Metal Type</h1>
                    <div className={bybStyle.bybFilterInnerbox}>
                      <ul className={bybStyle.bybFilterList}>
                        {Metals.map((Metal, idx) => (
                          <li>
                            <ToggleButton
                              key={idx}
                              id={`Metal-${idx}`}
                              type="radio"
                              variant={"outline-defult"}
                              name="Metal"
                              value={Metal.value}
                              checked={MetalValue === Metal.value}
                              onChange={(e) =>
                                setMetalValue(e.currentTarget.value)
                              }
                            >
                              <div>
                                <img alt="" src={Metal.imageUrl} /> <br />
                                <span>{Metal.name}</span>
                              </div>
                            </ToggleButton>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={bybStyle.bybFilterboxInner} id="color">
                    <h1 className={bybStyle.bybFilterTitle}> Color</h1>
                    <div className={bybStyle.bybFilterInnerbox}>
                      <ul className={bybStyle.bybFilterList}>
                        {colors.map((color, idx) => (
                          <li>
                            <ToggleButton
                              key={idx}
                              id={`color-${idx}`}
                              type="radio"
                              variant={"outline-defult"}
                              name="color"
                              value={color.value}
                              checked={colorValue === color.value}
                              onChange={(e) =>
                                setcolorValue(e.currentTarget.value)
                              }
                            >
                              <div>
                                <img alt="" src={color.imageUrl} /> <br />
                                <span>{color.name}</span>
                              </div>
                            </ToggleButton>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={bybStyle.bybFilterboxInner} id="finish">
                    <h1 className={bybStyle.bybFilterTitle}> Finish</h1>
                    <div className={bybStyle.bybFilterInnerbox}>
                      <ul className={bybStyle.bybFilterList}>
                        {finishs.map((finish, idx) => (
                          <li>
                            <ToggleButton
                              key={idx}
                              id={`finish-${idx}`}
                              type="radio"
                              variant={"outline-defult"}
                              name="finish"
                              value={finish.value}
                              checked={finishValue === finish.value}
                              onChange={(e) =>
                                setfinishValue(e.currentTarget.value)
                              }
                            >
                              <div>
                                <img alt="" src={finish.imageUrl} /> <br />
                                <span>{finish.name}</span>
                              </div>
                            </ToggleButton>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={bybStyle.bybFilterboxInner} id="width">
                    <h1 className={bybStyle.bybFilterTitle}> Width (MM)</h1>
                    <div className={bybStyle.bybFilterInnerbox}>
                      <ul className={bybStyle.bybFilterList}>
                        {widths.map((width, idx) => (
                          <li>
                            <ToggleButton
                              key={idx}
                              id={`width-${idx}`}
                              type="radio"
                              variant={"outline-defult"}
                              name="width"
                              value={width.value}
                              checked={widthValue === width.value}
                              onChange={(e) =>
                                setwidthValue(e.currentTarget.value)
                              }
                            >
                              <div>
                                {width.imageUrl ? (
                                  <img alt="" src={width.imageUrl} />
                                ) : null}
                                <span>{width.name}</span>
                              </div>
                            </ToggleButton>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={bybStyle.bybFilterboxInner} id="thickness">
                    <h1 className={bybStyle.bybFilterTitle}> Thickness</h1>
                    <div className={bybStyle.bybFilterInnerbox}>
                      <ul className={bybStyle.bybFilterList}>
                        {Thickness.map((Thicknes, idx) => (
                          <li>
                            <ToggleButton
                              key={idx}
                              id={`Thicknes-${idx}`}
                              type="radio"
                              variant={"outline-defult"}
                              name="Thicknes"
                              value={Thicknes.value}
                              checked={ThicknesValue === Thicknes.value}
                              onChange={(e) =>
                                setThicknesValue(e.currentTarget.value)
                              }
                            >
                              <div>
                                <img alt="" src={Thicknes.imageUrl} /> <br />
                                <span>{Thicknes.name}</span>
                              </div>
                            </ToggleButton>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div> */}
                {/* <div
                    className={
                      bybStyle.bybFilterboxInner +
                      " " +
                      bybStyle.bybFilterboxInnerSize
                    }
                    id="size"
                  >
                    <h1 className={bybStyle.bybFilterTitle}> Size</h1>
                    <div className={bybStyle.bybFilterInnerbox}>
                      <select className={bybStyle.bybFilterList}>
                        {Sizes.map((Size, idx) => (
                          <option value={Size.name}>{Size.name}</option>
                          // <li>
                          //   <ToggleButton
                          //     key={idx}
                          //     id={`Size-${idx}`}
                          //     type="radio"
                          //     variant={"outline-defult"}
                          //     name="Size"
                          //     value={Size.value}
                          //     checked={SizeValue === Size.value}
                          //     onChange={(e) => setSizeValue(e.currentTarget.value)}
                          //   >
                          //     <span>{Size.name}</span>
                          //   </ToggleButton>
                          // </li>
                        ))}
                      </select>
                    </div>
                  </div> */}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};

export default BandBuilder;
